import EpgContentSkeleton from '@/components/epg/components/programView/EpgContentSkeleton'
import TvContentSkeleton from '@/components/tv/components/TvContentSkeleton'
import VodContentSkeleton from '@/features/VOD/components/skeletons/VodContentSkeleton'

import { epgPagePath } from '@/shared/constants/epgConstants'
import { homePagePath } from '@/shared/constants/homeConstants'
import { tvPagePath } from '@/shared/constants/tvConstants'
import { vodPagePath } from '@/shared/constants/vodConstants'
import React, { Suspense } from 'react'

interface Props {
    children: JSX.Element
    actualPath: string
}

const ContentSuspense = ({ children, actualPath }: Props) => {
    const chooseSkeleton = () => {
        switch (actualPath) {
            case tvPagePath:
                return <TvContentSkeleton />
            case epgPagePath:
                return <EpgContentSkeleton />
            case vodPagePath:
                return <VodContentSkeleton rows={5} items={6} />
            case homePagePath:
                return <VodContentSkeleton rows={5} items={6} />
            default:
                return <TvContentSkeleton />
        }
    }
    return <Suspense fallback={chooseSkeleton()}>{children}</Suspense>
}

export { ContentSuspense }
